__turbopack_context__.v({
  "root": "GlobalFallback-module-scss-module__C8l4ZW__root",
});
